import React, { useState } from 'react';
import { Row, Col, Form, Input, message, Button } from 'antd';
// , Alert, Spin
import { HeartOutlined, LoadingOutlined } from '@ant-design/icons';
// import { LoadingOutlined } from '@ant-design/icons';
// import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import styles from './index.module.less';
import { Message, Icon } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import Logo from '@/common/assets/images/LoginPage1.png';
// import martrimonyLogo from '@/common/assets/icons/logo.svg';
import martrimonyLogo from '@/common/assets/images/LogoHeaer.png';
// import { LoadingOutlined } from '@ant-design/icons';
import { get_generateOTP } from '../../redux/slice';
import { useNavigate } from 'react-router-dom';

// import FormItem from '@/common/FormItem';
// import CustomButton from '@/common/CustomButton';
// import { CheckCircleOutlined } from '@ant-design/icons';

const LoginPage = ({ onSubmit }) => {
  // loading, otploading
  const [errorMsg] = useState('');
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  // const [otp, setOtp] = useState(true);
  const [loading, setLoading] = useState(false);
  const [otpGenerated, setOtpGenerated] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '']);

  const generateOTP = async (formValues) => {
    const { user_name } = formValues;
    let payload = { user_name };
    // const payload = JSON.stringify({ user_name });

    // console.log('payload_otp', payload);

    try {
      const response = await dispatch(get_generateOTP(payload)).unwrap();
      console.log('response', response.success);
      // console.log(
      //   'Success value:',
      //   response.success,
      //   'Type:',
      //   typeof response.success
      // );
      if (response?.success === true || response?.success === 'true') {
        setOtpGenerated(true);
        setOtp(['', '', '', '']);
        message.success(response?.message || 'OTP sent successfully!');
      } else {
        setOtpGenerated(false);
        message.error(
          response.message || 'Failed to generate OTP. Please try again.'
        );
      }
    } catch (error) {
      setOtpGenerated(false);
      message.error(
        error.message ||
          'An error occurred while generating OTP. Please try again.'
      );
    }
  };

  // const handleChange = (value, index) => {
  //   console.log('Input value:', value);
  //   setOtp((prevOtp) => {
  //     const newOtp = [...prevOtp];
  //     newOtp[index] = value;
  //     // Ensure the form stays updated with the latest OTP value
  //     form.setFieldsValue({ otp: newOtp.join('') });
  //     console.log('Updated OTP array:', newOtp);
  //     // Auto-focus to the next box if value is entered
  //     if (value && index < 3) {
  //       document.getElementById(`otp-${index + 1}`).focus();
  //     }
  //     return newOtp;
  //   });
  // };
  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return; // Only allow numbers

    setOtp((prevOtp) => {
      const newOtp = [...prevOtp];
      newOtp[index] = value;

      form.setFieldsValue({ otp: newOtp.join('') });

      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }

      // console.log('Updated OTP:', newOtp);

      // ✅ Ensure the form submits when 4 digits are entered
      if (
        newOtp.every((digit) => digit !== '') &&
        newOtp.join('').length === 4
      ) {
        // console.log('Submitting Form:', newOtp.join(''));
        setTimeout(() => form.submit(), 100); // 🔥 Add delay to allow re-render
      }

      return newOtp;
    });
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  // const handleMobileChange = (e) => {
  //   const value = e.target.value;
  //   const numericValue = value.replace(/\D/g, ''); // Remove non-numeric characters

  //   // Update form field with cleaned numeric value
  //   form.setFieldsValue({ user_name: numericValue });

  //   // ✅ Trigger OTP generation when a 10-digit number is entered
  //   if (numericValue.length === 10 && !otpGenerated) {
  //     form
  //       .validateFields(['user_name'])
  //       .then((values) => {
  //         setLoading(true); // Start loader
  //         generateOTP(values)
  //           .then(() => {
  //             setOtpGenerated(true); // Mark OTP as generated
  //           })
  //           .catch((error) => {
  //             console.error('OTP Generation Failed:', error);
  //           })
  //           .finally(() => {
  //             setLoading(false); // Stop loader
  //           });
  //       })
  //       .catch((errorInfo) => {
  //         console.error('Validation Failed:', errorInfo);
  //       });
  //   }
  // };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, ''); // Remove non-numeric characters

    form.setFieldsValue({ user_name: numericValue });

    if (numericValue.length === 10 && !otpGenerated) {
      form
        .validateFields(['user_name'])
        .then(async (values) => {
          setLoading(true);
          const isSuccess = await generateOTP(values);
          if (isSuccess) {
            setOtpGenerated(true); // ✅ Only if OTP was actually sent
          }
        })
        .catch((errorInfo) => {
          console.error('Validation Failed:', errorInfo);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onFinish = (values) => {
    // console.log('values', values);
    const { user_name } = values;
    const otpValue = otp.join('');
    if (otpValue.length === 4) {
      // console.log('Submitting with OTP:', { ...values, otp: otpValue });
      let payload = { user_name, otp: otpValue };
      // console.log('payload', payload);
      onSubmit(payload, otp);
    }
  };
  // const customLoader = <LoadingOutlined style={{ color: '#faf1d9' }} spin />;

  const handleNavigate = () => {
    navigate('/welcome');
  };
  return (
    <>
      <Row className={styles.mainContainerStyle}>
        <Col
          xs={24}
          xl={11}
          md={24}
          sm={24}
          lg={24}
          className={styles.backgroundImg}
        >
          <img className={`${styles.left_logo}`} src={Logo} />
        </Col>

        <Col
          xs={24}
          xl={13}
          sm={24}
          md={24}
          lg={24}
          className={styles.sideheader}
        >
          <div
            className={styles.headerload}
            onClick={handleNavigate}
            style={{ cursor: 'pointer' }}
          >
            <img
              src={martrimonyLogo}
              alt="matrimony logo"
              className={styles.logostyles}
            />
          </div>
          <div className={styles.sideheader1}>
            <h1 className={styles.headingsmall}>Ready to meet</h1>
            <h1 className={styles.someonestyles}>SOMEONE</h1>
            <h1 className={styles.someonestyles}>WHO GETS YOU?</h1>
          </div>
          <div className={styles.right_outer_container}>
            <Form
              form={form}
              layout="vertical"
              className={`ant-form ant-form-vertical mt-4 ${styles.form_width}`}
              onFinish={onFinish}
            >
              {/* <Form.Item
                label={<span className={styles.label}>Mobile No.</span>}
                name="user_name"
                rules={[
                  { required: true, message: 'Required field' },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: 'Please enter a valid 10-digit mobile number'
                  }
                ]}
              >
                <Input
                  placeholder="Enter your mobile number"
                  className={styles.input}
                  maxLength={10}
                  onChange={(e) => {
                    const value = e.target.value;
                    const numericValue = value.replace(/\D/g, ''); // Remove non-numeric characters

                    form.setFieldsValue({ user_name: numericValue });

                    // ✅ Call generateOTP when 10-digit number is entered
                    if (numericValue.length === 10 && !otpGenerated) {
                      form
                        .validateFields(['user_name'])
                        .then((values) => {
                          generateOTP(values);
                        })
                        .catch((errorInfo) => {
                          console.error('Validation Failed:', errorInfo);
                        });
                    }
                  }}
                />
              </Form.Item> */}
              <Form.Item
                label={<span className={styles.label}>Mobile</span>}
                name="user_name"
                rules={[
                  { required: true, message: 'Required field' },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: 'Please enter a valid 10-digit mobile number'
                  }
                ]}
              >
                {/* {loading ? (
                  <Spin tip="Generating OTP...">
                    <Alert
                      message="Processing your request"
                      // description="Please wait while we generate your OTP."
                      // type="info"
                    />
                  </Spin>
                ) : ( */}
                {/* {loading ? (
                  <div className={styles.loaderContainer}>
                    <LoadingOutlined
                      style={{ fontSize: 24, color: '#D32F2F' }}
                      spin
                    />
                    <p className={styles.loaderText}>
                      Verifying your number...
                    </p>
                  </div> */}
                {/* {loading ? (
                  <div className={styles.loaderContainer}>
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{ fontSize: 32, color: '#D32F2F' }}
                          spin
                        />
                      }
                    />
                    <p className={styles.loaderText}>
                      Verifying your profile...
                    </p>
                  </div> */}
                {loading ? (
                  <div className={styles.loaderContainer}>
                    <HeartOutlined className={styles.heartbeat} />
                    <p className={styles.loaderText}>
                      Finding your perfect match...
                    </p>
                  </div>
                ) : (
                  <Input
                    placeholder="Enter your mobile number"
                    className={styles.input}
                    maxLength={10}
                    onChange={handleMobileChange}
                  />
                )}
              </Form.Item>
              <Form.Item
                // label={<span className={styles.label}>OTP</span>}
                label={
                  otpGenerated ? (
                    <span className={styles.label}>OTP</span>
                  ) : null
                }
                name="otp"
                rules={[
                  {
                    required: true,
                    message: (
                      <span
                        className={styles.errorMessage}
                        style={{ marginLeft: '55px' }}
                      >
                        Required field
                      </span>
                    )
                  },
                  {
                    validator: (_, value) =>
                      value?.length === 1
                        ? Promise.resolve()
                        : // : Promise.reject(new Error('OTP must be 4 digits'))
                          Promise.reject(
                            <span
                              className={styles.errorMessage}
                              style={{ marginLeft: '55px' }}
                            >
                              OTP must be 4 digits
                            </span>
                          )
                  }
                ]}
              >
                {otpGenerated ? (
                  <div className={styles.otpContainer}>
                    {otp.map((digit, index) => (
                      <Input
                        key={index}
                        id={`otp-${index}`}
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        className={styles.otpInput}
                      />
                    ))}
                  </div>
                ) : (
                  ''
                )}
              </Form.Item>
              {otpGenerated &&
                otp.join('').length === 4 && ( // Auto-submit when 4 digits entered
                  <div
                    className={styles.loaderContainer}
                    style={{ marginLeft: '55px' }}
                  >
                    <LoadingOutlined
                      style={{ fontSize: 24, color: '#D32F2F' }}
                      spin
                    />
                    <p className={styles.loaderText}>Verifying OTP...</p>
                  </div>
                )}

              {otpGenerated ? (
                <Col span={24} xs={8} xl={24} sm={6} md={10}>
                  <Button
                    type="link"
                    onClick={() => {
                      form
                        .validateFields(['user_name'])
                        .then((values) => {
                          generateOTP(values);
                        })
                        .catch((errorInfo) => {
                          console.error('Validation Failed:', errorInfo);
                        });
                    }}
                    className="d-block mb-4 sfprotext-medium font-12"
                  >
                    Regenerate OTP?
                  </Button>
                </Col>
              ) : (
                ''
              )}
              {/* <br />
              {otpGenerated && otp && (
                <>
                  <Row gutter={24} className={styles.remember}>
                    <Col span={20} xs={16} xl={16} sm={10} md={16}>
                      <FormItem>
                        <CustomButton
                          // block
                          type="primary"
                          htmlType="submit"
                          // loading={loading}
                          loading={
                            loading ? { indicator: customLoader } : false
                          }
                          className={styles.login_button}
                        >
                          Sign in
                        </CustomButton>
                      </FormItem>
                    </Col>
                  </Row>
                </>
              )}  */}
            </Form>
          </div>
        </Col>
      </Row>
      <div>
        {errorMsg && (
          <Message negative>
            <Icon name="warning" />
            {errorMsg}
          </Message>
        )}
      </div>
    </>
  );
};

export default LoginPage;
